import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilingFilters, ITaxExpertFilters, IUserFilters } from "../../config/interfaces";
import { RootState } from "../Store";

interface FilterState {
  userFilters: IUserFilters | null;
  filingFilters: IFilingFilters | null;
  taxExpertFilters: ITaxExpertFilters | null;
}

const initialState: FilterState = {
  userFilters: null,
  filingFilters: null,
  taxExpertFilters: null
};

const FilterSlice = createSlice({
  name: "FilterSlice",
  initialState,
  reducers: {
    setUserFilters: (state, action: PayloadAction<IUserFilters | null>) => {
      state.userFilters = action.payload;
    },
    unsetUserFilters: (state) => {
      state.userFilters = null;
    },
    setFilingFilters: (state, action: PayloadAction<IFilingFilters | null>) => {
      state.filingFilters = action.payload;
    },
    unsetFilingFilters: (state) => {
      state.filingFilters = null;
    },
    setTaxExpertFilters: (state, action: PayloadAction<ITaxExpertFilters | null>) => {
      state.taxExpertFilters = action.payload;
    },
    unsetTaxExpertFilters: (state) => {
      state.taxExpertFilters = null;
    }
  }
});

export const {
  setUserFilters,
  unsetUserFilters,
  setFilingFilters,
  unsetFilingFilters,
  setTaxExpertFilters,
  unsetTaxExpertFilters
} = FilterSlice.actions;

export const userFiltersSelector = (rootState: RootState) => rootState.filterReducer.userFilters;
export const taxExpertFiltersSelector = (rootState: RootState) =>
  rootState.filterReducer.taxExpertFilters;

export const filingFiltersSelector = (rootState: RootState) =>
  rootState.filterReducer.filingFilters;

export default FilterSlice.reducer;
